<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; padding-left: 50px; font-size: 14px;" :flat='true'>

        <p>Федеральное государственное бюджетное учреждение <a href="http://nrcki.ru/" target="_blank">«Национальный исследовательский центр «Курчатовский институт»</a> приглашает научное сообщество принять участие в Курчатовском форуме «Исследования с применением синхротронного излучения, нейтронов и электронов» (Курчатов ФСНЭ 2026), который состоится 11–13 ноября 2026 года в Москве на территории <a href="https://club.nrcki.ru/" target="_blank">Дома ученых НИЦ «Курчатовский институт»</a>, г. Москва, ул. Рогова, д.1.
        </p>
        <p>Форум Курчатов ФСНЭ проводится с 2023 года и в 2026 году собирается в четвертый раз. Форум служит площадкой профессионального диалога исследователей, работающих на уникальных установках класса мегасайенс, и за прошедшие годы закрепился в качестве основной в стране площадки для обсуждения результатов, полученных методами синхротронного излучения, нейтронной диагностики и электронной микроскопии, рассмотрения научных программ создаваемых установок и согласования приоритетов развития исследовательской инфраструктуры в интересах технологического лидерства Российской Федерации.
        </p>
        <p>
          Страны-лидеры в сфере науки рассматривают установки мегакласса как ключевой элемент научно-технологического развития, обеспечивающий одновременно фундаментальные результаты и практические решения для отраслей промышленности. НИЦ «Курчатовский институт» относится к немногим центрам мира, где исследовательский реактор, источник синхротронного излучения и парк электронных микроскопов размещены на одной площадке, что открывает возможности для междисциплинарных работ в материаловедении, биофизике, науках о жизни и смежных областях.
        </p>
        <!-- <p>
          Установки класса «мегасайенс» считаются ключевым элементом научно-технологического развития, обеспечивающим одновременно фундаментальные научные результаты и практические решения для целого ряда отраслей промышленности. НИЦ «Курчатовский институт» относится к немногим центрам мира, где источник синхротронного излучения, исследовательский реактор и парк электронных микроскопов размещены на одной площадке, что открывает возможности для междисциплинарных работ в материаловедении, биофизике, науках о жизни и смежных областях.
        </p> -->
        <p>
          Программа Форума расширяется вместе с задачами профильной Федеральной научно-технической программы. В 2023 году Форум собрал 280 участников из 42 научных организаций, в 2024 году участников было уже 390 из 78 организаций, а в программу впервые вошел формат прямого диалога ученых с индустриальными партнерами, в прошлом 2025 году количество участников выросло до 469 человек, представляющих более 86 организаций. На форуме были представлены доклады по таким ключевым направлениям развития мегасайенса, как создание новых функциональных материалов и катализаторов для промышленности, исследования биологических систем на стыке физики и химии, развитие методов синхротронной визуализации и электронно-ионной микроскопии.        </p>
        <p>
          В 2026 году отдельное внимание планируется уделить развитию сети исследовательских установок и единым принципам обеспечения пользовательского доступа, ходу создания источника синхротронного и лазерного излучения «СИЛА» и научной программе рентгеновского лазера на свободных электронах, вычислительной инфраструктуре обработки экспериментальных данных, а также взаимодействию с индустриальными партнерами и научными организациями дружественных стран.
          <!-- В 2026 году отдельное внимание планируется уделить развитию сети исследовательских установок и единым принципам обеспечения пользовательского доступа, ходу создания источника синхротронного и лазерного излучения «СИЛА» и научной программе рентгеновского лазера на свободных электронах, вычислительной инфраструктуре обработки экспериментальных данных, а также взаимодействию с индустриальными партнерами и научными организациями дружественных стран. Сохраняются форматы предыдущих лет: тематические научные секции, круглые столы по отдельным направлениям, постерные сессии, школа молодых ученых и профильные симпозиумы. -->
        </p>
        <!-- <p>
          <b :style="{color: $mainColor}">Школа молодых ученых «Современные подходы к созданию детекторных материалов»</b> проводится в целях ознакомления молодых исследователей с последними достижениями и тенденциями в области материалов для детекторов ионизирующих излучений, а также их применения. Мероприятие призвано создать уникальную научную атмосферу для открытого профессионального общения, способствующую повышению квалификации и компетенций участников, раскрытию интеллектуального потенциала молодых учёных и налаживанию совместной работы в этом перспективном направлении. В рамках школы будут рассмотрены вопросы теории и практики детекторных материалов – от фундаментальных аспектов взаимодействия излучения с веществом до прикладных технологий. Программа охватывает моделирование сцинтилляционных процессов, спектроскопию перспективных материалов, оптимизацию свойств керамических материалов с содопированием, разработку порошковых сцинтилляторов и композитных экранов, аддитивные технологии, радиационную чистоту материалов и детекторы нейтронов. Приглашаем принять участие в работе школы ведущих ученых и экспертов в области детекторов ионизирующих излучений, а также молодых ученых и специалистов в возрасте до 35 лет включительно, аспирантов (ординаторов, интернов), студентов очной формы обучения, работников и членов экспертных советов Российского научного фонда.
        </p> -->

      <v-chip
        class="mt-8"
        dark
        outlined
        label
        color="#ff810a"
        style="margin-left: -20px; margin-bottom: 6px;"
      >
          <h3 :style="{color: $mainColor}"><b>ОСНОВНЫЕ ТЕМАТИЧЕСКИЕ НАПРАВЛЕНИЯ ФОРУМА:</b></h3>
      </v-chip>
      <!-- <p class="mb-0">
        ОСНОВНЫЕ ТЕМАТИЧЕСКИЕ НАПРАВЛЕНИЯ ФОРУМА:
      </p> -->
      <ul class="custom-list">
        <li>Национальная сеть установок класса «мегасайенс»</li>
        <li>Инфраструктура и аппаратурно-методическое обеспечение синхротронных и нейтронных экспериментов</li>
        <li>Синхротронные и нейтронные методы в материаловедении и индустриальных задачах</li>
        <li>Синхротронные и нейтронные методы в структурной биологии и науках о жизни</li>
        <li>Синхротронные и нейтронные методы в исследовании объектов культурного наследия</li>
        <li>Компактные источники нейтронов в прикладных и фундаментальных задачах</li>
        <li>Методы микроскопии и визуализации структуры вещества</li>
        <li>Времяразрешающие и когерентные методы на источниках синхротронного излучения и рентгеновских лазерах на свободных электронах</li>
        <li>Вычислительные методы, цифровая инфраструктура и технологии искусственного интеллекта в исследованиях на установках класса «мегасайенс»</li>
        <li>Кадровое обеспечение установок класса «мегасайенс»</li>
      </ul>

      <v-chip
        class="mt-8"
        dark
        outlined
        label
        color="#ff810a"
        style="margin-left: -20px; margin-bottom: 6px;"
      >
          <h3 :style="{color: $mainColor}"><b>КЛЮЧЕВЫЕ ДАТЫ:</b></h3>
      </v-chip>
      <!-- <p class="mb-0 mt-4">
        КЛЮЧЕВЫЕ ДАТЫ:
      </p> -->
      <ul style="list-style: none; padding-left: 0;">
        <li><b :style="{color: $mainColor}">11 сентября 2026</b> – начало электронной регистрации и приема тезисов докладов</li>
        <li><b :style="{color: $mainColor}">21 октября 2026</b> – окончание электронной регистрации и приема тезисов докладов</li>
        <li><b :style="{color: $mainColor}">29 октября 2026</b> – второе информационное письмо и публикация научной программы Форума Курчатов ФСНЭ 2026 </li>
        <li><b :style="{color: $mainColor}">29 октября 2026</b> – подтверждение очного участия в Форуме</li>
        <li><b :style="{color: $mainColor}">11–13 ноября 2026</b> – дни проведения Форума Курчатов ФСНЭ 2026</li>
      </ul>

      <p class="mt-4 mb-0">
        По результатам работы Форума Участникам будут направлены именные сертификаты. Предусмотрено только очное участие в следующих форматах:
      </p>
      <ul class="custom-list">
        <li><u>Участник с устным докладом:</u> имеет возможность принимать участие во всех мероприятиях Форума, публикация в сборнике тезисов;</li>
        <li><u>Участник со стендовым докладом:</u> имеет возможность принимать участие во всех мероприятиях Форума, публикация в сборнике тезисов;</li>
        <li><u>Слушатель (без доклада):</u> имеет возможность принимать участие во всех мероприятиях Форума, публикация в сборнике тезисов не предусмотрена.</li>
      </ul>

      <p class="mt-4">
        <a href="https://rsini.ru/personal-data">В личном кабинете</a> участник может загрузить свои <a href="https://rsini.ru/theses">тезисы доклада</a>, а также скачать приглашение на Форум на русском языке после подтверждения участия.
        <!-- <a href="https://rsini.ru/personal-data">В Личном кабинете</a> участник может загрузить свои тезисы доклада, а также сгенерировать приглашение на Форум на русском языке после подтверждения участия. -->
      </p>
      <p>
        Организационный взнос <b :style="{color: $mainColor}">не предусмотрен</b>.
      </p>
      <p>
        Рабочий язык - <b :style="{color: $mainColor}">русский</b>.
      </p>

  </v-card>
  
</div>

</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

const reEmail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

export default {
  name: 'HomePage',
  data() {
    return {

    };

  },
};
</script>

<style scoped>
.custom-list {
  list-style: none; 
  padding-left: 0;
}

.custom-list li {
  position: relative;
  padding-left: 24px;
  margin-bottom: 8px;
}

.custom-list li::before {
  content: "✓"; 
  position: absolute;
  left: 0;
  color: #185ba6;
  font-weight: bold;
}
</style>

<style lang="scss" scoped>
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgb(0, 0, 0);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
}
</style>